import React, { Component, Fragment } from "react";
import Paper from "../components/Paper";
import { Grid } from "@material-ui/core";
import Table from "../components/DashTable";
import { dashboardCardData } from "../data/dashboard";

export default class Dashboard extends Component {
	renderCard = () => {
		if (dashboardCardData.length) {
			return dashboardCardData.map(item => (
				<Grid item xs={3} style={{ textAlign: "center" }}>
					<Paper title={item.title} value={item.value} />
				</Grid>
			));
		}
	};

	render() {
		return (
			<Fragment>
				<Grid container spacing={3} className="mb-2">
					{this.renderCard()}
				</Grid>
				<Table />
			</Fragment>
		);
	}
}
